'use client';

import { ReactNode, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

type PortalProps = {
  children: ReactNode;
  containerId: string;
  renderInlineWhenMissing?: boolean;
};

const Portal = ({
  children,
  containerId,
  renderInlineWhenMissing = false
}: PortalProps): ReactNode => {
  const [container, setContainer] = useState<HTMLElement | null>(null);

  useEffect(() => {
    setContainer(document.getElementById(containerId));
  }, [containerId]);

  if (!container) {
    return renderInlineWhenMissing ? children : null;
  }

  return createPortal(children, container);
};

export default Portal;
